import { SxProps } from '@mui/material'

interface ZoomControlStyles {
  wrapper: SxProps
  buttonWrapper: SxProps
  button: SxProps
}

export const zoomControlStyles: ZoomControlStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 3,
  },
  buttonWrapper: {
    backgroundColor: 'background.default',
    borderRadius: 1.5,
  },
  button: {
    p: 0.75,
    borderRadius: 1.5,
    border: '1px solid',
    borderColor: 'button.borderSecondary',
    color: 'button.textDisabledSecondary',
    backgroundColor: 'button.backgroundSecondary',
    width: 32,
    height: 32,
    boxShadow:
      '0 0 0 1px rgba(10, 13, 18, 0.18) inset, 0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05)',
  },
}
